import { UrlEventType, UrlParameter } from 'src/requester';
import {
  IKameleoonData,
  KameleoonData,
  TargetedSegmentDataType,
} from './types';
import { TrackingStatus } from 'src/types';

export class TargetedSegment implements IKameleoonData {
  public status: TrackingStatus;

  private id: number;

  constructor(id: number) {
    this.id = id;
    this.status = TrackingStatus.Unsent;
  }

  get url(): string {
    return UrlEventType.TargetingSegment + UrlParameter.Id + this.id;
  }

  get data(): TargetedSegmentDataType {
    return {
      id: this.id,
      type: KameleoonData.TargetedSegment,
      status: this.status,
    };
  }

  public static _fromRaw(data: TargetedSegmentDataType): TargetedSegment {
    const { id, status } = data;

    const targetedSegment = new TargetedSegment(id);
    targetedSegment.status = status;

    return targetedSegment;
  }
}
